// 受注配車入力一覧内の定数

import { T受注配車入力GridItem } from "./TZyutyuHaisyaList"

export const 荷主Bindings = [
  "荷主コード",
  "荷主名",
  "表紙名",
  "荷主請求ID",
  "荷主依頼番号",
  "荷主略称1",
]
export const パターンBindings = ["パターンコード", "パターン検索"]
export const 積日Bindings = ["積日", "積時間"]
export const 卸日Bindings = ["卸日", "卸時間"]
export const 積地Bindings = [
  "積地積卸先コード",
  "積地社名",
  "積地都道府県",
  "積地市区町村",
]
export const 卸地Bindings = [
  "卸地積卸先コード",
  "卸地社名",
  "卸地都道府県",
  "卸地市区町村",
]

export const 品名Bindings = [
  "品コード",
  "品名",
  "積載品数量",
  "単位区分コード",
  "単位区分名称1",
]

export const 車輌Bindings = [
  "配車状態区分",
  "付替区分",
  "運行部所コード",
  "傭車会社コード",
  "支払先コード",
  "傭車会社名",
  "車番",
  "車輌ID",
  "車種区分コード",
  "最大積載量",
  "車輌最大積載量",
  "トレーラ車番",
  "トレーラ車輌ID",
  "トレーラ車種区分コード",
  "トレーラ車種区分名称1",
  "乗務員名",
  "同乗者名",
  "同乗者乗務員名",
  "同乗場所区分コード",
  "同乗者場所区分ID",
  "車種区分名称1",
]

export const 請求Bindings = [
  "請求内訳コード",
  "荷主請求内訳ID",
  "請求区分コード",
  "単価",
  "請求車番",
  "履歴検索",
  "タリフ検索",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料税込区分コード",
  "請求高速料税込区分名称1",
  "請求高速料",
  "請求合計",
  "計上基準日区分コード",
  "請求計上日",
  "計上基準日区分名称",
  "請求備考",
  "請求額確認区分名称1",
  "高速料記号",
  "請求車輌ID",
]

export const 乗務員売上Bindings = [
  "食事手当",
  "稼働手当車種掛率",
  "乗務員売上額",
  "乗務員付帯料",
  "付帯高速料",
  "特別手当",
  "is乗務員売上手編集",
  "稼働手当車種掛率区分コード",
  "同乗者売上額",
]
export const 支払Bindings = [
  "支払運送料",
  "支払付帯料",
  "支払高速料",
  "支払合計",
  "date支払計上日",
  "支払計上日",
  "支払備考",
]

export const alignRightBindings: (keyof T受注配車入力GridItem)[] = [
  "乗務員売上額",
  "その他手当",
  "最大積載量",
  "トレーラ車種最大積載量",
  "積地数",
  "卸地数",
  "品数",
  "繰返運行数",
  "積載品数量",
  "単価",
  "請求運送料",
  "請求付帯料",
  "請求高速料",
  "請求合計",
  "支払運送料",
  "支払付帯料",
  "支払高速料",
  "支払合計",
  "食事手当",
]

export const 分割受注配車子入力不可Bindings: (keyof T受注配車入力GridItem)[] = [
  "パターンコード",
  "荷主コード",
  "荷主請求ID",
  "荷主依頼番号",
  "積日",
  "積時間",
  "卸日",
  "卸時間",
  "繰返運行数",
  "積地積卸先コード",
  "積地社名",
  "積地都道府県",
  "積地市区町村",
  "卸地積卸先コード",
  "卸地社名",
  "卸地都道府県",
  "卸地市区町村",
  "品名",
  "品コード",
  "積載品数量",
  "単位区分コード",
  "荷主請求内訳ID",
  "請求区分コード",
  "単価",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料",
  "請求備考",
  "支払運送料課税区分コード",
  "支払運送料",
  "支払付帯料課税区分コード",
  "支払付帯料",
  "支払高速料",
  "支払計上日",
  "支払備考",
]
